const parseEnvList = (value) =>
  (value || '')
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean);

const ADMIN_EMAILS = parseEnvList(process.env.REACT_APP_ADMIN_EMAILS);
const ADMIN_UIDS = parseEnvList(process.env.REACT_APP_ADMIN_UIDS);

export const isAdminUser = (user, userDoc = {}) => {
  if (!user) return false;

  const email = user.email?.toLowerCase();
  const uid = user.uid?.toLowerCase();

  if ((email && ADMIN_EMAILS.includes(email)) || (uid && ADMIN_UIDS.includes(uid))) {
    return true;
  }

  const docRole = userDoc.role || userDoc.userRole || userDoc.roleId;
  return typeof docRole === 'string' && docRole.toLowerCase() === 'admin';
};

export const formatFsTimestamp = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value === 'number') return new Date(value);
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : new Date(parsed);
  }
  if (value.seconds) return new Date(value.seconds * 1000);
  return null;
};

